module.exports = __webpack_public_path__ + "static/media/17.df9ee56c.jpg";